module.exports = __webpack_public_path__ + "static/img/leiniao_visitor_bg_btn.a872b0a4.png";